<template>
  <div
    :class="{ 'octobus__container': !isFullWidth }"
    class="ticket octobus__box">
    <div class="octobus__columns">
      <div class="octobus__column">
        <div class="is-inline-block-touch time-block">
          <span class="time-departure is-block-touch has-text-weight-bold">
            {{ trip.dtDep | time }}
          </span>
          <span class="date-departure is-block-touch">
            {{ trip.dtDep | shortDate}}
          </span>
        </div>
        <div class="is-inline-block-touch address-block">
          <span class="city-departure is-block-touch">
            {{ trip.stDepName}}
          </span>
          <span class="address-departure is-block-touch">
            {{ trip.stDepAddr}}
          </span>
        </div>
      </div>
      <div class="octobus__column duration-block">
        <div class="is-inline-block-touch trip-arrow-div time-block is-size-4 is-hidden-tablet">
          <font-awesome-icon :icon="arrowDownLong" />
        </div>
        <div class="is-inline-block-touch has-text-weight-bold">
          <span class="time-inway">
            {{$t('ticket.inway', {wayTimeH: trip.wayTimeH, wayTimeM: trip.wayTimeM})}}
          </span>
        </div>
        <div class="is-inline-block-touch has-text-weight-bold">
          <ChangeBus
            :forward="route.forward.length"
            :backward="route.backward.length"
          />
        </div>
      </div>
      <div class="octobus__column">
        <div class="is-inline-block-touch time-block">
          <span class="time-arrived is-block-touch has-text-weight-bold">
            {{ trip.dtArr | time}}
          </span>
          <span class="date-arrived is-block-touch">
            {{ trip.dtArr | shortDate}}
          </span>
        </div>
        <div class="is-inline-block-touch address-block">
          <span class="city-arrived is-block-touch">
            {{ trip.stArrName}}
          </span>
          <span class="address-departure is-block-touch">
            {{ trip.stArrAddr}}
          </span>
        </div>
      </div>
      <div class="octobus__column is-hidden-touch">
        <div class="is-inline-block-touch time-block"></div>
        <div class="is-inline-block-touch">
          <span class="is-hidden-tablet">{{$t('ticket.free')}}</span>
          <span class="places">{{ trip.places }}</span>
        </div>
      </div>
      <div class="octobus__column">
        <div class="octobus__columns is-mobile has-text-weight-bold has-text-primary is-vcentered">
          <div class="octobus__column">
            <p class="old-price has-text-dark has-text-weight-normal" v-if="trip.discPerc">{{ trip.price | currency(currencySymbol) }}</p>
            <p class="ticket__price">{{ isBack ? (trip.discPerc ? trip.discPrice : trip.price) : trip.fullPrice | currency(currencySymbol) }}</p>
          </div>
          <div class="octobus__column is-hidden-desktop">
            <a
              class="octobus__button is-primary is-fullwidth"
              @click="handleToCheckout"
            >{{$t('ticket.buy')}}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="octobus__columns is-vcentered">
      <div class="octobus__column is-three-fifths has-text-centered-mobile is-size-7 has-text-weight-light is-hidden-touch">
        <p class="carrier">{{$t('ticket.carrier', {carrier: trip.carrier})}}</p>
      </div>
      <div class="octobus__column has-text-centered-touch is-size-6 has-text-weight-bold">
        <p class="details-button" @click="showDetails()">
          {{$t('ticket.showMore')}}
          <font-awesome-icon :icon="iconArrow" />
        </p>
      </div>
      <div class="octobus__column is-hidden-touch"  v-if="!isBack">
        <a
          class="octobus__button is-primary"
          @click="handleToCheckout"
        >{{$t('ticket.buy')}}</a>
      </div>
    </div>
    <div class="octobus__columns" v-if="show && !loading.route">
      <div class="octobus__column">
        <Details
          :routes="route.forward"
          :carrier="trip.carrier"
        />
      </div>
    </div>

    <div class="is-divider" :data-content="$t('ticket.backward')" v-if="isBack"></div>

    <div class="octobus__columns" v-if="isBack">
      <div class="octobus__column">
        <div class="is-inline-block-touch time-block">
          <span class="time-departure is-block-touch has-text-weight-bold">
            {{ trip.backDtDep | time }}
          </span>
          <span class="date-departure is-block-touch">
            {{ trip.backDtDep | shortDate}}
          </span>
        </div>
        <div class="is-inline-block-touch">
          <span class="city-departure is-block-touch">
            {{ trip.backStDepName}}
          </span>
          <span class="address-departure is-block-touch">
            {{ trip.bakcStDepAddr}}
          </span>
        </div>
      </div>
      <div class="octobus__column duration-block">
        <div class="is-inline-block-touch trip-arrow-div time-block is-size-4 is-hidden-desktop">
          <font-awesome-icon :icon="arrowDownLong" />
        </div>
        <div class="is-inline-block-touch has-text-weight-bold">
          <span class="time-inway">
            {{$t('ticket.inway', {wayTimeH: trip.backWayTimeH, wayTimeM: trip.backWayTimeM})}}
          </span>
        </div>
        <div class="is-inline-block-touch has-text-weight-bold">
          <ChangeBus
            :forward="route.forward.length"
            :backward="route.backward.length"
          />
        </div>
      </div>
      <div class="octobus__column">
        <div class="is-inline-block-touch time-block">
          <span class="time-arrived is-block-touch has-text-weight-bold">
            {{ trip.backDtArr | time}}
          </span>
          <span class="date-arrived is-block-touch">
            {{ trip.backDtArr | shortDate}}
          </span>
        </div>
        <div class="is-inline-block-touch">
          <span class="city-arrived is-block-touch">
            {{ trip.backStArrName}}
          </span>
          <span class="address-departure is-block-touch">
            {{ trip.backStArrAddr}}
          </span>
        </div>
      </div>
      <div class="octobus__column is-hidden-touch">
        <div class="is-inline-block-touch time-block"></div>
        <div class="is-inline-block-touch">
          <span class="is-hidden-desktop">{{$t('ticket.free')}}</span>
          <span class="places">{{ trip.backPlaces}}</span>
        </div>
      </div>
      <div class="octobus__column">
        <div class="octobus__columns is-mobile has-text-weight-bold has-text-success is-vcentered">
          <div class="octobus__column">
            <p class="old-price has-text-dark has-text-weight-normal" v-if="trip.backDiscPerc">{{ trip.backPrice | currency(currencySymbol) }}</p>
            <p class="ticket__price">{{ trip.backDiscPerc ? trip.backDiscPrice : trip.backPrice | currency(currencySymbol) }}</p>
          </div>
          <div class="octobus__column is-hidden-desktop">
            <a
              class="octobus__button is-primary is-fullwidth"
              @click="handleToCheckout"
            >{{$t('ticket.buy')}}</a>
          </div>
        </div>
        <div class="octobus__columns">
          <div class="octobus__column">
            <span>{{$t('ticket.sum')}}</span> <span class="has-text-weight-bold has-text-success">{{trip.fullPrice | currency(currencySymbol)}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="octobus__columns is-vcentered" v-if="isBack">
      <div class="octobus__column is-three-fifths has-text-centered-touch is-size-7 has-text-weight-light">
        <p class="carrier">{{$t('ticket.carrier', {carrier: trip.backCarrier})}}</p>
      </div>
      <div class="octobus__column has-text-centered-touch is-size-6 has-text-weight-bold">
        <p class="details-button" @click.prevent="toggle('showBack')">
          {{$t('ticket.showMore')}}
          <font-awesome-icon :icon="iconArrow" />
        </p>
      </div>
      <div class="octobus__column is-hidden-touch">
        <a
          class="octobus__button is-primary"
          @click="handleToCheckout"
        >{{$t('ticket.buy')}}</a>
      </div>
    </div>
    <div class="octobus__columns" v-if="showBack && !loading.route">
      <div class="octobus__column">
        <Details
          :routes="route.backward"
        />
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import { getFileName, errorFromBlob } from '@/utils/utils';
import moment from 'moment';
import FileSaver from 'file-saver';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faLongArrowAltDown, faAngleDown, faAngleUp, faDownload, faPrint, faBan } from '@fortawesome/fontawesome-free-solid';
import ChangeBus from './ChangeBus';
import Details from './Details';

export default {
  name: 'Ticket',
  components: {
    Details,
    ChangeBus,
    FontAwesomeIcon,
  },
  data() {
    return {
      show: false,
      showBack: false,
      loading: {
        route: true,
        link: false,
      },
      route: {
        forward: [],
        backward: [],
      },
    };
  },
  props: {
    trip: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleToCheckout() {
      const { children } = this.$router.options.routes[1];
      const route = children.find(r => r.name === 'Checkout');
      const passcount = Number(localStorage.getItem('__octobus__search-cnt')) || 1;

      if (this.$newTab) {
        if (this.$search) {
          window.open(`/${route.path}?id=${this.trip.tripId}&passcount=${passcount}`, '_blank');
        } else {
          const routeData = this.$router.resolve(`/${route.path}?id=${this.trip.tripId}&passcount=${passcount}`);
          window.open(routeData.href, '_blank');
        }
      } else if (this.$search) {
        location.href = `/${route.path}?id=${this.trip.tripId}&passcount=${passcount}`;
      } else {
        this.$router.push({ name: 'Checkout', query: { id: this.trip.tripId, passcount: passcount.toString() } });
      }
    },
    toggle(field) {
      this[field] = !this[field];
    },
    async downloadTicket() {
      const { buyId } = this.trip;

      if (!buyId) { return true; }

      this.loading.link = true;

      try {
        const response = await api.Content.exportPDF({ buyId });
        const fileName = getFileName(response);

        if (!response.ok) {
          const err = await errorFromBlob(response.body);
          throw new Error(err);
        }

        FileSaver.saveAs(response.body, fileName);
      } finally {
        this.loading.link = false;
      }
      return true;
    },
    printTicket() {
      const { buyId: buyid } = this.trip;

      this.$emit('printTicket', buyid);
    },
    cancelTicket() {
      this.$emit('showRfund', {
        buyId: this.trip.buyId,
        ticketId: this.trip.ticketId,
      });
    },
    showDetails() {
      this.show = !this.show;

      if (this.show && !this.route.forward.length) {
        const { tripId } = this.trip;

        if (tripId) {
          api.Trip.route(tripId).then((res) => {
            this.loading.route = false;
            const { forward, backward } = res;
            this.route.forward = forward || [];
            this.route.backward = backward || [];
          });
        }
      }
    },
  },
  computed: {
    arrowDownLong() {
      return faLongArrowAltDown;
    },
    isBack() {
      return Boolean(this.trip.backTripId);
    },
    downloadIcon() {
      return faDownload;
    },
    printIcon() {
      return faPrint;
    },
    cancelIcon() {
      return faBan;
    },
    currencySymbol() {
      const name = this.$root.octobusCurrency ? this.$root.octobusCurrency.name : '';
      const currency = name || this.$root.octobusCurrencyObj;

      return typeof currency === 'object' ? currency.name : currency;
    },
    iconArrow() {
      return this.show || this.showBack ? faAngleUp : faAngleDown;
    },
    isFullWidth() {
      return this.$fullwidth;
    },
    pathToCheckout() {
      const { children } = this.$router.options.routes[1];
      const route = children.find(r => r.name === 'Checkout');

      return this.$search ? `/${route.path}` : route.path;
    },
  },
  filters: {
    time(dateSring) {
      return moment(dateSring).format('HH:mm');
    },
    date(dateSring) {
      return moment(dateSring).format('ddd, Do MMMM');
    },
    shortDate(dateSring) {
      return moment(dateSring).format('ddd, Do MMM');
    },
  },
};
</script>

<style scoped lang="scss">

/* Small Devices, Tablets */
@media only screen and (max-width : 1023px) {
  #app, #auth {
    .trip-info {

      .time-block {
        margin-right: 0.7rem !important;
      }
    }
  }
}

#app, #auth {
  .ticket {
    .is-divider {
      border-top-width: 0.01rem;

      &:after {
        padding: 0.3rem .8rem;
      }
    }

    .details-button {
      cursor: pointer;
    }

    .old-price {
      text-decoration: line-through;
    }

    .octobus__cancel,
    .octobus__print,
    .octobus__download {
      cursor: pointer;
      display: inline-block;
    }
  }
}

/* Small Devices, Tablets */
@media only screen and (max-width : 768px) {
  #app, #auth {
    .ticket {
      line-height: 1;
      padding: 0.5rem;

      .address-block {
        font-size: 16px;
        font-weight: 300;
        line-height: 17px;
        max-width: calc(100% - 100px);
      }

      .city-departure,
      .city-arrived {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .time-block {
        min-width: 90px;
      }

      .time-departure,
      .time-arrived {
        font-size: 1.1rem;
      }

      .date-departure,
      .date-arrived {
        font-size: 12px;
      }

      .trip-arrow-div {
        padding-left: 1rem;
      }
      .duration-block {
        padding: 0 0.75rem;
      }

      .time-inway {
        font-size: 0.8rem;
      }

      .octobus__box {
        padding: 1rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Ticket/Ticket.vue